import React from 'react';

import Resources from "../Resources";

function createColumnDefs() {
  const columnDefs = [
    { name: 'ResourceId', options: { display: true, filter: false } },
    { name: 'ResourceSubtype', label: 'Workload Type', options: { filter: true } },
    { name: 'ClientAccountId', options: { display: false, filter: true } },
    { name: 'Description', options: { display: true, filter: true } },
    { name: 'ResourceType', options: { display: false, filter: false } },
    { name: 'StackUpdated', options: { display: true } },
  ];
  return columnDefs;
}

export default function Workloads(props) {

  const columnDefs = createColumnDefs();

  return (
    <Resources 
      type='Workload' 
      columnDefs={columnDefs} 
    />
  );
}

Workloads.propTypes = {
};

Workloads.defaultProps = {
};
